import { getInputDate } from "@/utils";
class MyTasks_v2 {
  taskQueueId = 0;
  processName = "";
  activityType = "";
  dueDate = getInputDate(new Date());
  initiatedBy = "";
  initiatedByName = "";
  referenceId = "";
  assignedTo = "";
  assignedToName = "";

  constructor(
    taskQueueId,
    processName,
    activityType,
    dueDate,
    initiatedBy,
    initiatedByName,
    referenceId,
    assignedTo,
    assignedToName
  ) {
    this.taskQueueId = taskQueueId;
    this.processName = processName;
    this.activityType = activityType;
    this.dueDate = dueDate;
    this.initiatedBy = initiatedBy;
    this.initiatedByName = initiatedByName;
    this.referenceId = referenceId;
    this.assignedTo = assignedTo;
    this.assignedToName = assignedToName;
  }
}

export { MyTasks_v2 };
